export default __webpack_public_path__ + "static/media/SETTINGS (dark).f83fd667.png";